import { render, staticRenderFns } from "./ServerTimeoutPage.vue?vue&type=template&id=2f8f7801&scoped=true"
import script from "./ServerTimeoutPage.vue?vue&type=script&lang=js"
export * from "./ServerTimeoutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f7801",
  null
  
)

export default component.exports